// extracted by mini-css-extract-plugin
export default {"hover":"card_hover__mjwHG"};